import {
  ButtonGroup,
  PrimaryButton,
  SecondaryButton,
} from "@digipost/dds-buttons-react";
import { Heading } from "@digipost/dds-heading-react";
import Infobox from "@digipost/dds-infobox-react";
import { Spinner } from "@digipost/dds-spinner-react";
import { useLanguage } from "@digipost/translate";
import { FC, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import {
  SiteImproveActions,
  SiteImproveCategories,
  siteImproveEvent,
} from "../analytics/SiteImprove";
import { post } from "../infrastructure/digipost-fetch";
import { findURIWithWindowHostname } from "../infrastructure/linkUtils";
import { Dispatch } from "../infrastructure/redux/actions";
import { logoutAction } from "../infrastructure/redux/app/app-actions";
import { ReduxState } from "../infrastructure/redux/state";
import Translated from "../infrastructure/Translated";
import { useRootPath } from "../infrastructure/useRootPath";
import { useTranslate } from "../infrastructure/useTranslate";

export const PersonGjenapne: FC = () => {
  const translate = useTranslate();
  const rootPath = useRootPath();
  const { language } = useLanguage();

  const dispatch = useDispatch<Dispatch>();

  const link = useSelector((state: ReduxState) => state.link);
  const csrfToken = useSelector((state: ReduxState) => state.app.csrfToken);

  const [error, setError] = useState<Error | undefined>(undefined);
  const [loading, setLoading] = useState<boolean>(false);

  useEffect(() => {
    document.title = `Digipost - ${translate("person.gjenapne.header")}`;
  }, [translate]);

  const reopenAccount = async (): Promise<void> => {
    try {
      setLoading(true);
      const uri = findURIWithWindowHostname("reopen_account", link);
      await post(uri, {}, csrfToken, `${rootPath}/person?logout=1`);
      window.location.href = `/postkasse/?language=${language}`;
    } catch (err) {
      setError(err as Error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Heading level={1} size="large">
        <Translated textKey="person.gjenapne.header" />
      </Heading>

      <Translated textKey="person.gjenapne.info" allowHtml={true} />

      <div role="alert">
        {error && (
          <Infobox
            variant="error"
            level={2}
            title={translate("generic.error")}
          />
        )}
      </div>

      <ButtonGroup>
        <PrimaryButton
          onClick={() => {
            siteImproveEvent({
              category: SiteImproveCategories.PERSON_REGISTRATION,
              action: SiteImproveActions.REOPEN,
              label: "/person",
            });
            reopenAccount();
          }}
          iconRight={loading && <Spinner />}
        >
          <Translated textKey="person.gjenapne.button" />
        </PrimaryButton>
        <SecondaryButton
          onClick={() => {
            siteImproveEvent({
              category: SiteImproveCategories.PERSON_REGISTRATION,
              action: SiteImproveActions.CANCEL,
              label: "/person",
            });
            dispatch(logoutAction());
          }}
        >
          <Translated textKey="generic.cancel" />
        </SecondaryButton>
      </ButtonGroup>
    </>
  );
};
